/**
 * API Error represents network, connection, or server errors
 * These errors are retryable for queries (see useApiQuery)
 */
export class APIError extends Error {
  readonly statusCode: number;
  readonly isRetryable: boolean;

  constructor(message: string, statusCode = 0) {
    super(message);
    this.name = "APIError";
    this.statusCode = statusCode;
    // Retryable: network errors (0), 5xx server errors, 408 timeout, 429 rate limit
    this.isRetryable =
      statusCode === 0 ||
      statusCode >= 500 ||
      statusCode === 408 ||
      statusCode === 429;
  }
}

/**
 * Validation Error represents contract/schema mismatches
 * These errors are NOT retryable (won't fix on retry)
 */
export class ValidationError extends Error {
  readonly details?: Record<string, unknown>;

  constructor(message: string, details?: Record<string, unknown>) {
    super(message);
    this.name = "ValidationError";
    this.details = details;
  }
}
